import { useEffect, useState } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { SliceHealthStatus } from '@ui/__generated__/graphql'
import { DatableDataType } from '@ui/interfaces'
import { UpdateNodeStatusMutation } from '@ui/loaders/workflow'
import { SliceToggleSwitch } from '@ui/pages/pipelinesWorkflow/components/SliceToggleSwitch'
import { useAuth } from '@ui/providers/AuthProvider.tsx'
import { useNodeAndEdgeStore } from '@ui/stores'

export const SliceStatusToggles = () => {
  // const [updateSliceStatusQuery] = UpdateSliceStatusQuery()
  const [updateNodeStatusQuery] = UpdateNodeStatusMutation()
  const [logStatus, setLogStatus] = useState<SliceHealthStatus>(SliceHealthStatus.Enabled)
  const [spanStatus, setSpanStatus] = useState<SliceHealthStatus>(SliceHealthStatus.Enabled)
  const [metricStatus, setMetricStatus] = useState<SliceHealthStatus>(SliceHealthStatus.Enabled)

  const [logEnabled, setLogEnabled] = useState<boolean>(true)
  const [spanEnabled, setSpanEnabled] = useState<boolean>(true)
  const [metricEnabled, setMetricEnabled] = useState<boolean>(true)

  const { isDemoMode } = useAuth()

  const { currentNodeId, nodes, setUpdatePipeline } = useNodeAndEdgeStore(
    useShallow((state) => ({
      currentNodeId: state.currentNodeId,
      nodes: state.nodes,
      setUpdatePipeline: state.setUpdatePipeline,
    }))
  )

  const currentNode = nodes.find((node) => node.id === currentNodeId)

  useEffect(() => {
    if (currentNode) {
      const { logsEnabled, spansEnabled, metricsEnabled, logsStatus, spansStatus, metricsStatus } =
        currentNode.data?.status || {}

      setLogStatus(logsStatus)
      setSpanStatus(spansStatus)
      setMetricStatus(metricsStatus)
      setLogEnabled(logsEnabled)
      setSpanEnabled(spansEnabled)
      setMetricEnabled(metricsEnabled)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSliceEnabledToggle = async (datatype: DatableDataType, status: SliceHealthStatus) => {
    if (isDemoMode) return

    const newEnabled = status == SliceHealthStatus.Failed || status === SliceHealthStatus.Disabled
    const newStatus = newEnabled ? SliceHealthStatus.Enabled : SliceHealthStatus.Disabled

    // Optimistically update the UI first
    switch (datatype) {
      case 'logs':
        setLogStatus(newStatus)
        setLogEnabled(newEnabled)
        break
      case 'spans':
        setSpanStatus(newStatus)
        setSpanEnabled(newEnabled)
        break
      case 'metrics':
        setMetricStatus(newStatus)
        setMetricEnabled(newEnabled)
        break
    }

    await updateNodeStatusQuery({
      variables: {
        nodeId: currentNodeId as string,
        status: {
          logsEnabled: datatype === 'logs' ? newEnabled : logEnabled,
          logsStatus: datatype === 'logs' ? newStatus : logStatus,
          spansEnabled: datatype === 'spans' ? newEnabled : spanEnabled,
          spansStatus: datatype === 'spans' ? newStatus : spanStatus,
          metricsEnabled: datatype === 'metrics' ? newEnabled : metricEnabled,
          metricsStatus: datatype === 'metrics' ? newStatus : metricStatus,
        },
      },
    })
    setUpdatePipeline(true)
  }

  return (
    <div className="mr-5 flex flex-row items-center space-x-5">
      <SliceToggleSwitch
        status={logStatus}
        checked={logEnabled}
        label={'Logs'}
        onChange={() => handleSliceEnabledToggle('logs', logStatus)}
      />
      <SliceToggleSwitch
        status={spanStatus}
        checked={spanEnabled}
        label={'Spans'}
        onChange={() => handleSliceEnabledToggle('spans', spanStatus)}
      />
      {/* <SliceToggleSwitch
        status={metricStatus}
        enabled={metricEnabled}
        label={'Metrics'}
        onChange={() => handleSliceEnabledToggle('metrics', metricStatus)}
      /> */}
    </div>
  )
}
